import script from "./LinkTileExternal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkTileExternal.vue?vue&type=script&setup=true&lang=ts"

import "./LinkTileExternal.vue?vue&type=style&index=0&id=4921b72b&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4921b72b"]])

export default __exports__